export const getRandomTop = () => {
  return Math.ceil(Math.random() * window.innerHeight);
};

export const getRandomLeft = () => {
  return Math.ceil(Math.random() * window.innerWidth);
};
